<div [class]="isLoading ? 'page-loader' : 'page-loader d-none'"></div>
<div (keydown.enter)="$event.preventDefault()">
  <div class="modal-header">
    <h4 class="modal-title w-100 text-center">Update Sample Product Note</h4>
  </div>
  <div class="modal-body">
    <div class="modal-body-inner">
      <div class="add-user-form">
        <div class="row">
          <div class="col">
            <div class="form-field form-group">
              <label class="grey-label">Product Name</label>
              <input class="form-control text-align" type="text" [value]="productName" readonly tabindex="-1"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-field form-group">
              <label class="grey-label" style="margin-bottom: 8px !important;">Notes</label>
              <textarea class="form-control text-align" [(ngModel)]="notes"
                        placeholder="Enter notes" rows="6" aria-label="Product notes"
                        (keydown.enter)="$event.stopPropagation()"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="dark-bordered-btn dont-send-btn" (click)="cancel()">Cancel</button>
    <button type="button" class="submit-btn-grey status-modal-save" [disabled]="isLoading" (click)="onSubmit()">
      Update
    </button>
  </div>
</div>
